export default "__VITE_ASSET__ByOD4OAQ__"